<div class="main">
  <div class="loader" *ngIf="showLoader">
    <div class="load">
      <mat-spinner></mat-spinner>
    </div>
  </div>
  <div class="section">
    <div class="filter">
      <div class="title">
        <div class="titleLabel">
          {{ "EXPRESS_SHIPMENTS_DASHBOARD.title" | translate }}
        </div>
        <!-- <div class="help">
          <app-help [helpData]="helpData"></app-help>
        </div> -->
        <div class="tabs">
          <div
            class="tab">
            Outbound
          </div>
          <div
            class="tab">
            Inbound
          </div>
          <!-- <div class="tab" (click)="changeShipmentType('others')" [ngClass]="{ selected: shipmentType == 'others' }">
              Others
            </div> -->
        </div>
      </div>
      <div class="input-container">
        <input
          
          [placeholder]="'EXPRESS_SHIPMENTS_DASHBOARD.search' | translate"
          class="inputSelect"
        />
        <div class="buttons" (click)="toggle()">
          <div
            class="mapView mat-elevation-z4"
            *ngIf="!showAdvanceSearch"
            style="width: 160px"
          >
            <div style="padding: 4px">
              {{ "EXPRESS_SHIPMENTS_DASHBOARD.advance_search" | translate }}
            </div>
          </div>
          <div
            class="mapView mat-elevation-z4"
            *ngIf="showAdvanceSearch"
            style="width: 190px"
          >
            <div style="padding: 4px">
              {{
                "EXPRESS_SHIPMENTS_DASHBOARD.closeAdvancedSearch" | translate
              }}
            </div>
          </div>
        </div>
        <div class="buttons" style="padding-left: 90px">
          <div class="mapView mat-elevation-z4">
            <div style="padding: 4px">
              {{ "EXPRESS_SHIPMENTS_DASHBOARD.map_view" | translate }}
            </div>
          </div>
          <!-- <div class="ganttView mat-elevation-z4" (click)="openGanttDashboard();">
                        <div style="padding: 4px;">
                          {{'EXPRESS_SHIPMENTS_DASHBOARD.ganttLabel' | translate}}
                        </div>
                      </div> -->
        </div>
      </div>
      <div
        class="refresh"
        (click)="paginator.pageIndex = 0;"
      >
        <i class="material-icons">refresh</i>
      </div>
    </div>

    <div class="advancedSearchSection" *ngIf="showAdvanceSearch">
      <div class="search">
        <div class="orgSection">
          <div class="label">
            {{ "EXPRESS_SHIPMENTS_DASHBOARD.organization" | translate }}
          </div>
          <div class="input">
            <mat-select class="inputSelect" style="color: #fff">
              <mat-option> select </mat-option>
            </mat-select>
          </div>
        </div>
        <div class="orgSection">
          <div class="label">
            {{ "EXPRESS_SHIPMENTS_DASHBOARD.shipper" | translate }}
          </div>
          <div class="input">
            <mat-select class="inputSelect" style="color: #fff">
              <mat-option> select </mat-option>
            </mat-select>
          </div>
        </div>
        <div class="orgSection">
          <div class="label">
            {{ "EXPRESS_SHIPMENTS_DASHBOARD.material" | translate }}
          </div>
          <div class="input">
            <mat-select multiple class="inputSelect" style="color: #fff">
              <mat-option> select </mat-option>
            </mat-select>
          </div>
        </div>

        <div class="invoiceSection">
          <div class="label">
            {{ "EXPRESS_SHIPMENTS_DASHBOARD.invoice" | translate }}
          </div>
          <div class="input">
            <input type="text" />
          </div>
        </div>
        <div class="invoiceSection">
          <div class="label">
            {{ "EXPRESS_SHIPMENTS_DASHBOARD.lrNo" | translate }}
          </div>
          <div class="input">
            <input type="text" />
          </div>
        </div>
      </div>
      <div class="search">
        <div class="orgSection">
          <div class="label">
            {{ "EXPRESS_SHIPMENTS_DASHBOARD.pick" | translate }}
          </div>
          <div class="input">
            <mat-select class="inputSelect" multiple style="color: #fff">
              <input
                class="searchInput"
                style="
                  background-color: #fff;
                  height: 100%;
                  border: solid 1px #e3e3e3;
                  width: 95%;
                  margin: 2%;
                  border-radius: 4px;
                "
              />
              <mat-option>
                <span style="font-weight: bold">select</span>
              </mat-option>
            </mat-select>
          </div>
        </div>
        <div class="orgSection">
          <div class="label">
            {{ "EXPRESS_SHIPMENTS_DASHBOARD.drop" | translate }}
          </div>
          <div class="input">
            <mat-select class="inputSelect" multiple style="color: #fff">
              <input
                class="searchInput"
                style="
                  background-color: #fff;
                  height: 100%;
                  border: solid 1px #e3e3e3;
                  width: 95%;
                  margin: 2%;
                  border-radius: 4px;
                "
              />
              <mat-option>
                <span style="font-weight: bold"></span> select
              </mat-option>
            </mat-select>
          </div>
        </div>
        <div class="fromSection">
          <div class="label">
            {{ "EXPRESS_SHIPMENTS_DASHBOARD.from" | translate }}
          </div>
          <div class="input">
            <input
              type="text"
              style="width: 40%"
              class="inputField"
              placeholder="Date"
              [matDatepicker]="fromDateInput"
            />
            <mat-datepicker #fromDateInput></mat-datepicker>
            <span class="material-icons dateIcon"> date_range </span>
          </div>
        </div>
        <div class="toSection">
          <div class="label">
            {{ "EXPRESS_SHIPMENTS_DASHBOARD.to" | translate }}
          </div>
          <div class="input">
            <input
              type="text"
              style="width: 40%"
              class="inputField"
              placeholder="Date"
              [matDatepicker]="toDateInput"
            />
            <mat-datepicker #toDateInput></mat-datepicker>
            <span class="material-icons dateIcon"> date_range </span>
          </div>
        </div>
        <div class="submitButton" (click)="submitSearch()">
          <div class="button">
            {{ "EXPRESS_SHIPMENTS_DASHBOARD.submit" | translate }}
          </div>
        </div>
        <div class="submitButtonClear" (click)="clear()">
          <div class="button">
            {{ "EXPRESS_SHIPMENTS_DASHBOARD.clear" | translate }}
          </div>
        </div>
      </div>
    </div>

    <div class="table">
      <table   mat-table    [dataSource]="dataSource"    matSort      (matSortChange)="sortShipmentData($event)"
      >
        <!-- <ng-container matColumnDef="sin">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="customHeader"
          >
            <span>
              <input
                type="text"
                style="width: 120px"
                [placeholder]="'EXPRESS_SHIPMENTS.Select' | translate"
                (click)="stopProp($event)"
                class="formField"
              />
            </span>
          </th>
          <td mat-cell *matCellDef="let element"></td>
        </ng-container> -->

        <ng-container matColumnDef="tripid">
          <th mat-header-cell *matHeaderCellDef class="customHeader">
            {{ "Trip ID & Type" | translate }}
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.shipment }}
            <br>
            {{element.trip_type}}
          </td>
        </ng-container>

        <ng-container matColumnDef="drop_location">
          <th mat-header-cell *matHeaderCellDef class="customHeader">
            {{ "Drop Location" | translate }}
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.drop_location }}
          </td>
        </ng-container>

        <ng-container matColumnDef="booking_date">
          <th mat-header-cell *matHeaderCellDef class="customHeader">
            {{ "Date of Booking" | translate }}
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.booking_date }}
          </td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef class="customHeader">
            {{ "Status" | translate }}
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.status }}
          </td>
        </ng-container>
        <ng-container matColumnDef="vehicle_type">
          <th mat-header-cell *matHeaderCellDef class="customHeader">
            {{ "Vehicle Type & No" | translate }}
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.status }}
          </td>
        </ng-container>

        <ng-container matColumnDef="ewaybill">
          <th mat-header-cell *matHeaderCellDef class="customHeader">
            {{ "Consolidated Eway Bill" | translate }}
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.type }}
          </td>
        </ng-container>

        <ng-container matColumnDef="action">
          <th mat-header-cell *matHeaderCellDef class="customHeader">
            <h3 class="action">
              {{ "EXPRESS_SHIPMENTS.actions" | translate }}
            </h3>
          </th>
          <td
            mat-cell
            *matCellDef="let element"
            (click)="$event.stopPropagation()"
          ></td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: columnsToDisplay"         
        ></tr>
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" colspan="4">No data matching the filter</td>
        </tr>
      </table>
      <mat-paginator
        [length]="dataSource ? totalOrders : 0"
        [showFirstLastButtons]="true"
        [pageSize]="25"
        style="border-top: solid 1px #ededed; border-bottom: solid 1px #ededed"
        [pageSizeOptions]="[5, 10, 25, 100]"
        (page)="pageNavigate($event)"
      ></mat-paginator>

      <ng-template #noOrders>
        <div class="noOrders">
          {{ "EXPRESS_SHIPMENTS.noShip" | translate }}
        </div>
      </ng-template>
    </div>

    <!-- <div class="table">
        <table mat-table 
          [dataSource]="" matSort (matSortChange)="sortShipmentData($event)">
  
          <ng-container matColumnDef="sin">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="customHeader">
              <span>
                <input type="text" style="width: 120px;" [placeholder]="'EXPRESS_SHIPMENTS_DASHBOARD.trip' | translate"
                     (click)="stopProp($event)"
                    class="formField" />
            </span>
            </th>
            <td mat-cell *matCellDef="let element">
             
            </td>
          </ng-container>
  
          <ng-container matColumnDef="pickup_drop">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="customHeader">
              <span>
                <input type="text" style="width: 120px;" [placeholder]="'EXPRESS_SHIPMENTS_DASHBOARD.pickup_location' | translate"
                     (click)="stopProp($event)"
                    class="formField" />
            </span>
            </th>
            <td mat-cell *matCellDef="let element">
              
            </td>
          </ng-container>
  
          <ng-container matColumnDef="date_time">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="customHeader">
              <span>
                <input type="text" style="width: 120px;" [placeholder]="'EXPRESS_SHIPMENTS_DASHBOARD.Date_of_booking' | translate"
                     (click)="stopProp($event)"
                    class="formField" />
            </span>
            </th>
            <td mat-cell *matCellDef="let element">
              
            </td>
          </ng-container>
  
          <ng-container matColumnDef="vehicle_details">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="customHeader"
              style="width: 15% !important; padding: 0% 1%;">
              <span>
                <input type="text" style="width: 120px;" [placeholder]="'EXPRESS_SHIPMENTS_DASHBOARD.status' | translate"
                     (click)="stopProp($event)"
                    class="formField" />
            </span>
            </th>
            <td mat-cell *matCellDef="let element">
             
  
            </td>
          </ng-container>
  
          <ng-container matColumnDef="driver">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              <span>
                <input type="text" style="width: 120px;" [placeholder]="'EXPRESS_SHIPMENTS_DASHBOARD.vehicle_type' | translate"
                     (click)="stopProp($event)"
                    class="formField" />
            </span>
            </th>
            <td mat-cell *matCellDef="let element">
             
            </td>
          </ng-container>
  
          <ng-container matColumnDef="distance">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="customHeader" style="width: 10% !important;">
              <span>
                <input type="text" style="width: 200px;" [placeholder]="'EXPRESS_SHIPMENTS_DASHBOARD.consolidated_ewaybill' | translate"
                     (click)="stopProp($event)"
                    class="formField" />
            </span>
            </th>
            <td mat-cell *matCellDef="let element">
              
            </td>
          </ng-container>
  
          <ng-container matColumnDef="action">
            <th mat-header-cell *matHeaderCellDef class="customHeader">
              <h3 class="action">
                {{'EXPRESS_SHIPMENTS_DASHBOARD.actions' | translate}}
              </h3>
            </th>
            <td mat-cell *matCellDef="let element" (click)="$event.stopPropagation();">
  
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
          <tr mat-row *matRowDef="let row; columns: columnsToDisplay;" (click)="openShipmentDetails(row);"
            >
        </tr>
        </table>
       
        <ng-template #noOrders>
          <div class="noOrders">
            {{'EXPRESS_SHIPMENTS_DASHBOARD.noShip' | translate}}
          </div>
        </ng-template>
      </div> -->
  </div>
</div>
<!-- <ng-template #warning>
    <div class="dialogMain">
      <div class="section">
        <div class="header">
          <div class="label">
            {{'EXPRESS_SHIPMENTS_DASHBOARD.re_assign' | translate}}<i class="material-icons"
              (click)="warningRef.close(false);">clear</i>
          </div>
        </div>
        <div class="text">
          {{'EXPRESS_SHIPMENTS_DASHBOARD.warningText' | translate}}
          <div class="reassign_radio_sec">
            <p>
              <input type="radio" id="test1" name="radio-group" checked [(ngModel)]="re_assign_type" value="driver">
              <label for="test1">{{'EXPRESS_SHIPMENTS_DASHBOARD.re_assign_driver' | translate}}</label>
            </p>
            <p class="reassign_radio_btn">
              <input type="radio" id="test2" name="radio-group" [(ngModel)]="re_assign_type" value="vehicle">
              <label for="test2">{{'EXPRESS_SHIPMENTS_DASHBOARD.re_assign_vehicle' | translate}}</label>
            </p>
            <p class="reassign_radio_btn">
              <input type="radio" id="test3" name="radio-group" [(ngModel)]="re_assign_type" value="both">
              <label for="test3">{{'EXPRESS_SHIPMENTS_DASHBOARD.both_driver_vehicle' | translate}}</label>
            </p>
          </div>
        </div>
        <div class="submitButton">
          <div class="button" (click)="warningRef.close(true);">
            {{'EXPRESS_SHIPMENTS_DASHBOARD.submit' | translate}}
          </div>
        </div>
      </div>
    </div>
  </ng-template>
  <ng-template #acceptDialog>
    <div class="dialogMain">
      <div class="section">
        <div class="header">
          <div class="label">
            {{'EXPRESS_SHIPMENTS_DASHBOARD.accept' | translate}}<i class="material-icons"
              (click)="acceptRef.close(false);">clear</i>
          </div>
        </div>
        <div class="text">
          {{'EXPRESS_SHIPMENTS_DASHBOARD.acceptText' | translate}}
        </div>
        <div class="submitButton">
          <div class="button" (click)="acceptRef.close(true);">
            {{'EXPRESS_SHIPMENTS_DASHBOARD.ok' | translate}}
          </div>
        </div>
      </div>
    </div>
  </ng-template>
  
  <ng-template #delayedShipment>
    <div class="delayDialog">
      <div class="loader" *ngIf="showLoader">
        <div class="load">
          <mat-spinner></mat-spinner>
        </div>
      </div>
      <div class="header">
        {{'EXPRESS_SHIPMENTS_DASHBOARD.delayed_shipment' | translate}}
        <i class="material-icons" (click)="delayedShipmentRef.close(false);">
          clear
        </i>
      </div>
      <div class="section">
        <div class="text">
          {{'EXPRESS_SHIPMENTS_DASHBOARD.delay_text' | translate}}
        </div>
        <div class="penalty_amount">
          {{'EXPRESS_SHIPMENTS_DASHBOARD.penalty_amount' | translate}} : {{shipmentDelayData.penalty}}
        </div>
        <div class="reasonBox">
          <textarea [required]="shipmentDelayData.reason" [placeholder]=" 'EXPRESS_SHIPMENTS_DASHBOARD.reason_waive' | translate "
            autofocus="false" [(ngModel)]="shipmentDelayData.reason"> </textarea>
        </div>
      </div>
  
      <div class="submitButton">
        <div class="button right-float" (click)="requestWaiveOff()" *ngIf="!shipmentDelayData.status">
          {{'EXPRESS_SHIPMENTS_DASHBOARD.waive_off' | translate}}
        </div>
        <div class="button left-float" (click)="delayedShipmentRef.close();" *ngIf="!shipmentDelayData.status">
          {{'EXPRESS_SHIPMENTS_DASHBOARD.cancel' | translate}}
        </div>
        <div class="disabled" *ngIf="shipmentDelayData && shipmentDelayData.status == 'PENDING'">
          {{'EXPRESS_SHIPMENTS_DASHBOARD.requested_already' | translate}}
        </div>
        <div class="green" *ngIf="shipmentDelayData && shipmentDelayData.status == 'APPROVED'">
          {{'EXPRESS_SHIPMENTS_DASHBOARD.approved' | translate}}
        </div>
      </div>
    </div>
  </ng-template> -->
